import { ABaseModel } from '../abstracts/ABaseModel.js';
import { ISelectionDimension, ISelectionValue, IFilterSelectionListResult } from '../interfaces/Filter.js';
import { ListResult } from './List.js';

/**
 * SelectionDimension
 */
class SelectionDimension extends ABaseModel implements ISelectionDimension {
  dimensionName: string;
  values: Array<SelectionValue>;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

/**
 * SelectionValue
 */
class SelectionValue extends ABaseModel implements ISelectionValue {
  display: string;
  value: string;
  child: SelectionDimension;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

/**
 * FilterSelectionListResult
 */
class FilterSelectionListResult extends ListResult implements IFilterSelectionListResult {
  declare items: Array<SelectionDimension>;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

export { SelectionDimension, SelectionValue, FilterSelectionListResult };
